import {css} from 'aphrodite';
import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ConditionGroup} from 'studies/typed/shared/procedure-runs/design-state/useExperimentDesignState';
import getTestProps from 'test/lib/cypress/getTestProps';

import {
  getConditionValidationTooltip,
  validateConditions,
} from '../design-state/procedureRunStudyValidationUtils';
import PublishedProcedureVersionUpdateBanner from '../procedure-selection/PublishedProcedureVersionUpdateBanner';
import {VersionUpdateProps} from './ProcedureRunPlanDesignContentTypes';
import {
  StudyDesignTabEditState,
  StudyDesignTabSaveButton,
  StudyDesignTabSavingIndication,
} from './StudyDesignTabSavingButtons';
import {studyDesignTabStyles} from './StudyDesignTabSharedComponents';

interface PlanDesignHeaderProps {
  conditions: Array<ConditionGroup>;
  editState: StudyDesignTabEditState;
  onSave: () => void;
  procedureType: ProcedureType;
  versionUpdate: VersionUpdateProps;
}

export default function LegacyProcedureRunPlanDesignSubHeader({
  conditions,
  editState,
  onSave,
  procedureType,
  versionUpdate,
}: PlanDesignHeaderProps): JSX.Element {
  return (
    <div
      className={css(studyDesignTabStyles.header, studyDesignTabStyles.planHeader)}
      {...getTestProps({component: 'LegacyProcedureRunPlanDesignSubHeader', element: 'root'})}
    >
      <div className={css(studyDesignTabStyles.tabTitle)}>Design</div>
      <div className={css(studyDesignTabStyles.bannerAndButtons)}>
        {versionUpdate.hasNewerVersion && (
          <PublishedProcedureVersionUpdateBanner
            procedureType={procedureType}
            onOpenUpdateModal={versionUpdate.onOpenUpdateModal}
            hasUnsavedChanges={versionUpdate.hasUnsavedChanges}
          />
        )}
        {editState === StudyDesignTabEditState.SAVING ? (
          <StudyDesignTabSavingIndication />
        ) : (
          <StudyDesignTabSaveButton
            isSaveDisabled={!validateConditions(conditions) || !versionUpdate.hasUnsavedChanges}
            saveDisabledTooltip={
              !validateConditions(conditions)
                ? (getConditionValidationTooltip(conditions) ?? undefined)
                : 'No changes to save'
            }
            onSave={onSave}
          />
        )}
      </div>
    </div>
  );
}
